import { defineMessages } from 'react-intl'

export default defineMessages({
  continueIn: {
    id: 'languageswitcher.continuein',
    defaultMessage: 'Continue in',
  },
  'en-GB': {
    id: 'languageswitcher.en-gb',
    defaultMessage: 'English (UK)',
  },
  'en-US': {
    id: 'languageswitcher.en-us',
    defaultMessage: 'English (US)',
  },
  'en-CA': {
    id: 'languageswitcher.en-ca',
    defaultMessage: 'English (CA)',
  },
  'es-US': {
    id: 'languageswitcher.es-us',
    defaultMessage: 'Spanish (US)',
  },
})
